import React, { useState, useEffect } from "react";
import NormalLayout from "../../components/layout/NormalLayout";
import axios from "axios";
import {
  Table,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

import Moment from "react-moment";
import { Cookies } from "react-cookie";
import CompanyForm from "../../components/admin/CompanyForm";

const cookies = new Cookies();

// 도매업체 관리
function AdminCompany() {
  const [companies, setCompanies] = useState(null);
  const [brands, setBrands] = useState(null);

  const [show, setShow] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  // const navigate = useNavigate(){}

  useEffect(() => {
    getWholesaler();
  }, []);

  const getWholesaler = async () => {
    try {
      const rawData = await axios.get(
        `${process.env.REACT_APP_WHOLESALE_API_URL}/admin/company`,
        {
          headers: {
            Authorization: cookies.get("info").token,
          },
        }
      );
      console.log(rawData.data);
      setCompanies(rawData.data.companies);
      setBrands(rawData.data.brands);
    } catch (error) {
      console.error("데이터를 불러오는데 실패했습니다", error);
    }
  };

  const handleAddCompany = async () => {
    setSelectedCompany(null);
    setShow(true);
  };

  const handleModify = (company) => {
    setSelectedCompany(company);
    setShow(true);
  };

  const handleDelete = async (id, name) => {
    // 사용자에게 확인을 요청하는 알림 표시
    const isConfirmed = window.confirm(`${name} 업체를 삭제하시겠습니까?`);

    if (isConfirmed) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_WHOLESALE_API_URL}/admin/company/${id}`,
          {
            headers: {
              Authorization: cookies.get("info").token,
            },
          }
        );
        getWholesaler();
      } catch (err) {
        console.error(err);
      }
    } else {
      // 사용자가 '취소'를 클릭했을 때 수행할 작업
      console.log("사용자가 삭제를 취소했습니다.");
    }
  };

  return (
    <NormalLayout>
      <div>
        <h3>도매업체 정보</h3>
      </div>

      <Modal isOpen={show} toggle={() => setShow(!show)} size="lg">
        <ModalHeader toggle={() => setShow(!show)}>
          {selectedCompany ? "도매업체 정보 수정" : "도매업체 추가"}
        </ModalHeader>
        <ModalBody>
          <CompanyForm
            fetchCompanies={getWholesaler}
            selectedCompany={selectedCompany}
            setSelectedCompany={setSelectedCompany}
            setShow={setShow}
            brands={brands}
          />
        </ModalBody>
      </Modal>

      <div className="p-3 text-end">
        <Button color="primary" onClick={() => handleAddCompany()}>
          + 도매업체 추가하기
        </Button>
      </div>
      {companies ? (
        <>
          <div className="border p-3">
            <Table hover bordered>
              <thead>
                <tr className="table-primary">
                  <th className="text-center">No</th>
                  <th className="text-center p-2 border">
                    거래처명(사업자등록증 기준)
                  </th>
                  <th className="text-center p-2 border">
                    업체명(주문서신청 기준)
                  </th>
                  <th className="text-center p-2 border">담당자명</th>
                  <th className="text-center p-2 border">전화</th>
                  <th className="text-center p-2 border">이메일</th>
                  <th className="text-center p-2 border">그룹</th>
                  <th className="text-center p-2 border">메모</th>
                  <th className="text-center p-2 border">등록일</th>
                  <th className="text-center p-2 border">브랜드</th>
                  <th className="text-center p-2 border">기능</th>
                </tr>
              </thead>
              <tbody>
                {companies.map((company, idx) => {
                  return (
                    <tr key={idx}>
                      <td className="text-center">{idx + 1}</td>
                      <td className="text-center">{company.company_name}</td>
                      <td className="text-center">{company.wholesaler}</td>
                      <td className="text-center">{company.manager_name}</td>
                      <td className="text-center">{company.manager_tel}</td>
                      <td className="text-center">{company.manager_email}</td>
                      <td className="text-center">{company.purchase_grade}</td>
                      <td className="text-center">{company.company_memo}</td>
                      <td className="text-center">
                        <Moment format="YYYY/MM/DD">
                          {company.created_at}
                        </Moment>
                      </td>
                      <td className="text-center">
                        {company.allow_all_brand ? (
                          <>전체노출</>
                        ) : (
                          <>노출제한</>
                        )}
                      </td>
                      <td className="text-center">
                        <button onClick={() => handleModify(company)}>
                          수정
                        </button>{" "}
                        <button
                          onClick={() =>
                            handleDelete(
                              company.company_index,
                              company.wholesaler
                            )
                          }
                        >
                          삭제
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </>
      ) : (
        <>등록된 도매업체 정보가 없습니다.</>
      )}
    </NormalLayout>
  );
}

export default AdminCompany;
